import { useQuery, useQueryClient } from "@tanstack/react-query";
import { GUIDES_KEY, guidesApi } from "@/lib/api/guides";
import { GUIDES_CHANGED_EVENT } from "@/lib/guides";
import { RECONNECT_EVENT, usePortalEvent } from "@/lib/portal-socket";

export const MY_GUIDES_KEY = ["guides", "list"] as const;

/** The member's guides (`/guides/me/`), with areas. */
export function useMyGuides(enabled = true, options: { refetchOnMount?: boolean | "always" } = {}) {
  return useQuery({
    queryKey: MY_GUIDES_KEY,
    queryFn: () => guidesApi.list().then((r) => r.data),
    staleTime: 60_000,
    enabled,
    ...options,
  });
}

/** Refetch every guide query when the backend pings `guides_changed` (a tick
 *  in another tab, a colleague ticking a company step, the office editing a
 *  guide) or the portal socket reconnects. */
export function useGuidesRealtime() {
  const qc = useQueryClient();
  const refresh = () => qc.invalidateQueries({ queryKey: GUIDES_KEY });
  usePortalEvent(GUIDES_CHANGED_EVENT, refresh);
  usePortalEvent(RECONNECT_EVENT, refresh);
}
